<template>
    <div class="lp_Developing">
        <el-image :src="imgName" fit="contain"></el-image>
        <div class="font">{{ text }}</div>
    </div>
</template>

<script>
    export default {
        name: "lp_Developing",
        data(){
            return{
                imgName:require('../../assets/images/building.png'),
            }
        },
        props:{
            text:{//文本
                type:String,
                default:'功能开发中，敬请期待…'
            }
        },
        methods: {

        },
    }
</script>

<style scoped lang="less">
    .lp_Developing{
        width: 100%;
        height: 100%;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .el-image{
            width: 160px;
            height: 160px;
        }
        .font{
            font-family: MicrosoftYaHeiUI;
            font-size: 14px;
            color: #666666;
            margin-top: 36px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/developing/index.vue